import { useState, useEffect } from 'react';
import './About.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import cn from 'classnames';
import Adv1 from '../../assets/adv1.jpg';
import Adv5 from '../../assets/adv5.jpg';
import Adv6 from '../../assets/adv6.jpg';
import Point5 from '../../assets/point5.png';
import Point8 from '../../assets/point8.png';
import Point9 from '../../assets/point9.png';
import Point10 from '../../assets/point10.png';
import Point11 from '../../assets/point11.png';
import Point12 from '../../assets/point12.png';
import Point13 from '../../assets/point13.png';
import Point1 from '../../assets/point1.png';
import Point4 from '../../assets/point4.png';
import Clients from '../../components/Clients';
import Reviews from '../../components/Reviews';
import Background from '../../assets/background.jpg';
import Form from '../../components/Form';
import WhoWeHire from '../../components/WhoWeHire';
import Image from './img1.jpg';

const AboutPage = ({ onFormClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isFormOpen, setFormOpen] = useState(false);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1200);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='mainScreen'>
        <span className='mainScreenTitle'>
          A smarter, <span>Human First</span> approach to recruitment, <span>Powered by AI.</span>
        </span>
        <span className='mainScreenText'>
          At NextDeavor, our mission is to connect people with teams, roles, and workplaces where they can grow, make an impact,
          and elevate those around them.
        </span>
      </div>

      <div className='pointsSection' style={{ marginTop: '0' }}>
        <span className='blockTitle' style={{ marginBottom: isMobile ? '40px' : '80px' }}>
          What we stand for
        </span>
        <div className='points' style={{ marginBottom: '16px' }}>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point9} />
            </span>
            <span className='pointTitle'>Trust and Relationships</span>
            <span className='pointText'>
              Our success is built on strong relationships and mutual trust, it’s the foundation that ensures long-term success
              for both clients and candidates.
            </span>
          </div>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point5} />
            </span>
            <span className='pointTitle'>White-Glove Experience</span>
            <span className='pointText'>
              We make every experience personal, never transactional, because we believe the heart of our work is about people,
              not just placements.
            </span>
          </div>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point10} />
            </span>
            <span className='pointTitle'>Long-Term Partnership</span>
            <span className='pointText'>
              We’re committed to the long-term success of both clients and candidates, offering ongoing guidance and insights well
              beyond the initial hire.
            </span>
          </div>
        </div>

        <div className='points'>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point11} />
            </span>
            <span className='pointTitle'>Innovation and technology</span>
            <span className='pointText'>
              We leverage human expertise and the power of AI to keep our clients ahead of the curve, delivering smarter, faster
              hiring solutions.
            </span>
          </div>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point12} />
            </span>
            <span className='pointTitle'>Data privacy</span>
            <span className='pointText'>
              We prioritize confidentiality, using advanced security measures to protect your proprietary information every step
              of the way.
            </span>
          </div>
          <div className='point'>
            <span className='pointIcon'>
              <img src={Point8} />
            </span>
            <span className='pointTitle'>Human Connections at Our Core</span>
            <span className='pointText'>
              AI helps us search smarter, but it’s our human relationships and networks that create lasting impact.
            </span>
          </div>
        </div>
      </div>

      <WhoWeHire />

      <div className='workWithUsDescription'>
        <div className='workWithUsDescriptionContent'>
          <span className='workWithUsDescriptionContentText'>
            Whether you’re a high-growth startup, a mid-sized business, or an established enterprise, we bring expertise across a
            wide range of industries to help you scale. From advanced fields like High Tech, SaaS, Semiconductors, Defense,
            Energy, Robotics, and AI to dynamic sectors such as Real Estate, Property Management, and Advanced Manufacturing — we
            tailor our approach to your unique needs.
            <br />
            <br />
            <b>Because every great company deserves the right partner to grow with.</b>
            <br />
            <br />
            Let’s build your next chapter together.
          </span>
          <span className='workWithUsDescriptionContentImage'>
            <img src={Image} />
          </span>
        </div>
        <span className='workWithUsDescriptionButton' onClick={() => setFormOpen(true)}>
          Work With Us{' '}
          <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none'>
            <path
              d='M18 3.375C15.1075 3.375 12.2799 4.23274 9.87479 5.83976C7.46972 7.44677 5.5952 9.73089 4.48827 12.4033C3.38134 15.0756 3.09171 18.0162 3.65602 20.8532C4.22033 23.6902 5.61323 26.2961 7.65857 28.3414C9.70391 30.3868 12.3098 31.7797 15.1468 32.344C17.9838 32.9083 20.9244 32.6187 23.5968 31.5117C26.2691 30.4048 28.5532 28.5303 30.1602 26.1252C31.7673 23.7201 32.625 20.8926 32.625 18C32.6209 14.1225 31.0788 10.4049 28.3369 7.66309C25.5951 4.92125 21.8775 3.37909 18 3.375ZM24.4209 18.7959L19.9209 23.2959C19.7098 23.507 19.4235 23.6256 19.125 23.6256C18.8265 23.6256 18.5402 23.507 18.3291 23.2959C18.118 23.0848 17.9994 22.7985 17.9994 22.5C17.9994 22.2015 18.118 21.9152 18.3291 21.7041L20.9095 19.125H12.375C12.0766 19.125 11.7905 19.0065 11.5795 18.7955C11.3685 18.5845 11.25 18.2984 11.25 18C11.25 17.7016 11.3685 17.4155 11.5795 17.2045C11.7905 16.9935 12.0766 16.875 12.375 16.875H20.9095L18.3291 14.2959C18.118 14.0848 17.9994 13.7985 17.9994 13.5C17.9994 13.2015 18.118 12.9152 18.3291 12.7041C18.5402 12.493 18.8265 12.3744 19.125 12.3744C19.4235 12.3744 19.7098 12.493 19.9209 12.7041L24.4209 17.2041C24.5255 17.3085 24.6085 17.4326 24.6651 17.5692C24.7218 17.7058 24.7509 17.8522 24.7509 18C24.7509 18.1478 24.7218 18.2942 24.6651 18.4308C24.6085 18.5674 24.5255 18.6915 24.4209 18.7959Z'
              fill='white'
            />
          </svg>
        </span>
      </div>

      <div className='advantages'>
        <div className='advantagesContent'>
          <span className='blockTitle'>
            Beyond our Initial Search, <span>We Support You through Closing Ideal Candidates.</span>
          </span>
          <div className='advantage'>
            <span className='advantageDescription'>
              While our AI technology accelerates the search, it’s our human expertise that ensures a perfect fit. We don’t just
              provide a list of candidates and step away, we guide you through every step, helping both you and the candidate feel
              confident in the decision.
            </span>
            <span className='advantageImage'>
              <img src={Adv1} />
            </span>
          </div>
          <div className='advantage'>
            <span className='advantageDescription'>
              Our personalized service extends all the way through the offer stage, ensuring both sides get what they need to make
              a lasting, successful match.
            </span>
            <span className='advantageImage'>
              <img src={Adv5} />
            </span>
          </div>
          <div className='advantage'>
            <span className='advantageDescription'>
              This blend of speed and personal support helps set your team up for long-term success.
            </span>
            <span className='advantageImage'>
              <img src={Adv6} />
            </span>
          </div>
          <span className='contactButton' onClick={() => setFormOpen(true)}>
            Find Next Great Hire
            <svg width='28' height='28' viewBox='0 0 28 28'>
              <path
                d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
                fill='white'
              />
            </svg>
          </span>
        </div>
      </div>

      <div className='aboutDetails'>
        <div className='aboutDetailsContent'>
          <div className='aboutDetailsInfo'>
            <div className='aboutDetail'>
              <span className='aboutDetailsIcon'>
                <img src={Point13} />
              </span>
              <span className='aboutDetailsTitle'>A Vision Aligned for Growth</span>
              <span className='aboutDetailsText'>
                Recruiting has been stuck in the past for too long with slow, transactional, and treating people like lines on a
                resume instead of dynamic, whole individuals. That’s exactly why <b>NextDeavor was founded.</b> Frustrated by the
                outdated, impersonal approach to hiring, we knew there had to be a better way, one that combined{' '}
                <b>technology, intuition, and a people-first mindset.</b>
              </span>
            </div>
            <div className='aboutDetail'>
              <span className='aboutDetailsIcon'>
                <img src={Point1} />
              </span>
              <span className='aboutDetailsTitle'>The Future of Staffing: Human-First, Powered by AI</span>
              <span className='aboutDetailsText'>
                At <b>NextDeavor,</b> we’re redefining the hiring experience by putting <b>people first.</b> We blend{' '}
                <b>human expertise</b> with
                <b>advanced AI</b> to create a smarter, faster, and more meaningful way to <b>connect talent with opportunity.</b>{' '}
                The future of work isn’t just about filling roles - it’s about building careers, nurturing growth, and matching
                the <b>right people</b>
                with the <b>right opportunities.</b>
              </span>
            </div>
            <div className='aboutDetail'>
              <span className='aboutDetailsIcon'>
                <img src={Point4} />
              </span>
              <span className='aboutDetailsTitle'>AI That Works for You</span>
              <ul className='aboutDetailsList'>
                <li>
                  <b>Smarter candidate</b> matching that goes beyond keywords, focusing on <b>true alignment.</b>
                </li>
                <li>
                  <b>Automation</b> that frees up recruiters to focus on what matters: <b>humans connecting with humans.</b>
                </li>
                <li>
                  <b>Real-time insights</b> to help you stay ahead of trends and make proactive, people-centered hiring decisions.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='clientsSection'>
        <span className='blockTitle'>Recent Clients Include…</span>
        <Clients />
      </div>

      <div className='adBlock'>
        <span className='adBlockBackgroung'>
          <img src={Background} />
        </span>
        <div className='adBlockDetails'>
          <span className='adBlockTitle'>
            Are we the <span>right fit</span> for you? Discover our <span>human-first</span> recruiting approach,{' '}
            <span>enhanced&nbsp;by&nbsp;AI.</span>
          </span>
        </div>
        <span className='adBlockButton' onClick={() => setFormOpen(true)}>
          Work With Us
          <svg width='28' height='28' viewBox='0 0 28 28'>
            <path
              d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
              fill='white'
            />
          </svg>
        </span>
      </div>

      <Reviews />
      <div className='spacer' />

      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default AboutPage;
